function copyToClipboard(element, code, product){
  if(code){
    // 1. Copy the text to clipboard
    navigator.clipboard.writeText(code).then(() => {
      
      // 2. Find the text container inside the clicked element
      const textElement = element.querySelector('.change-text');
      const originalText = textElement.getAttribute('data-original');

      // 3. Change the text
      textElement.innerHTML = "Code successfully copied!";
      send_evnt_data(code, product);

      // 4. Set a timeout to revert it after 3 seconds (3000ms)
      setTimeout(() => {
        textElement.innerHTML = originalText;
      }, 3000);
      
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }
}

function send_evnt_data(code, product=""){
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", "Bearer 7cbdee3765a5e5ce92ae1ada95d9ef7e");

  var raw = JSON.stringify({
    "project": "sutisaaj-web",
    "event": "Code Copy",
    "icon": "🎁",
    "tags": {
      "code": code,
      "product": product
    },
    "notify": false,
    "channel": "code-copy"
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };

  fetch("https://api.logsnag.com/v1/log", requestOptions)
    .then(response => response.text())
    .then(result => console.log(result))
    .catch(error => console.log('error', error));
}